import { colors } from '../../colors';
var card = {
  textColorDark: colors.nvaBlack,
  textColorLight: colors.white,
  bgColor: colors.nvaTeal,
  bgColorHero: colors.white,
  textAlignment: 'center'
};
export default card;